<div
  class="container d-flex align-items-center justify-content-center"
  style="min-height: 100vh"
>
  <div class="row">
    <div class="col-md-11 mx-auto">
      <div class="card card-signing flex-row my-5" style="border-radius: 1rem">
        <div
          class="card-body"
          style="background-color: white; border-radius: 1rem; height: 100%"
        >
          <div class="row justify-content-center">
            <div class="col-12">
              <form class="px-4" action="">
                <div class="row" style="margin-top: 20px">
                  <p class="lead">
                    Ne bucurăm că vrei să răspunzi la chestionarul nostru, dar
                    nu mai este valabil.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer
  *ngIf="
    surveyType === 'PLOOM3_1' ||
    surveyType === 'PLOOM3_3' ||
    surveyType === 'PLOOM3_6' ||
    surveyType === 'PLOOM3_12' ||
    surveyType === 'PLOOM4_1' ||
    surveyType === 'PLOOM4_3' ||
    surveyType === 'PLOOM4_6' ||
    surveyType === 'PLOOM4_12' ||
    surveyType === 'SurveyBurgundy'
  "
></app-footer>
